var map = {
	"./anz.svg": 1648,
	"./asb.svg": 4553,
	"./avanti.svg": 8285,
	"./bnz.svg": 8151,
	"./boc.svg": 7141,
	"./ccapital.svg": 3068,
	"./coop.svg": 9615,
	"./heartland.svg": 7374,
	"./hsbc.svg": 2844,
	"./icbc.svg": 8597,
	"./indi_purple.svg": 4951,
	"./kiwibank.svg": 9217,
	"./liberty.svg": 5020,
	"./pepper.svg": 8060,
	"./resimac.svg": 5998,
	"./sbs.svg": 5393,
	"./tsb.svg": 8090,
	"./westpac.svg": 9682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4483;